/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_No_EntriesInputs */

const fr_changelog_no_entries = /** @type {(inputs: Changelog_No_EntriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune entrée trouvée`)
};

/**

* @param {Changelog_No_EntriesInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const changelog_no_entries = /** @type {((inputs?: Changelog_No_EntriesInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_No_EntriesInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_changelog_no_entries(inputs)
});